
import * as handlebars_family from "../handlebars_family.ts";
import "../layout/layout_modal.mustache";
const TPL = handlebars_family.addTemplate("modal/congratulations",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  " <div class=\"modal V4\"><div class=\"title\"><icon class=\"modal-close\" data-fw-onclick=\"modalclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":122},"end":{"line":1,"column":144}}}))
    + "</icon> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"modalwelcome2.title",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":152},"end":{"line":1,"column":184}}})) != null ? stack1 : "")
    + " </div><div class=\"content\" style=\"text-align:justify\"><lottie-player autoplay loop mode=\"normal\" src=\"images/lottie/anim_confettis.json\" style=\"width: 120px;margin-left: auto;margin-right: auto;display:block\" class=\"blockmargin\" ></lottie-player> ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"user") || (depth0 != null ? lookupProperty(depth0,"user") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"user","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":432},"end":{"line":1,"column":495}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"user")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " <p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"modalcongratulations.textend",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":499},"end":{"line":1,"column":540}}})) != null ? stack1 : "")
    + "</p> "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"deepLoginLink") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data,"loc":{"start":{"line":1,"column":545},"end":{"line":1,"column":732}}})) != null ? stack1 : "")
    + " </div></div> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"modalcongratulations.text",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":444},"end":{"line":1,"column":482}}})) != null ? stack1 : "")
    + "</p>";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <a class=\"button\" href=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"deepLoginLink") : depth0), depth0))
    + "\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.start",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":612},"end":{"line":1,"column":638}}})) != null ? stack1 : "")
    + "</a> ";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <button data-fw-onclick=\"modalclose\">"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"actions.start",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":689},"end":{"line":1,"column":715}}})) != null ? stack1 : "")
    + "</button> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_modal"),depth0,{"name":"layout/layout_modal","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;